define('app/factories/owl_factory',['app/setup'],
  function (takhfifan) {
    $(document).ready(function () {
      var owl = $(".deals-owl-carousel");
      if (owl.length > 0) {
        owl.owlCarousel({
          autoplay: true,
          slideSpeed: 50,
          rewindSpeed: 50,
          loop: true,
          rtl: true,
          margin: 10,
          nav: true,
          navText: ["<i class='icon-arrow-right'></i>", "<i class='icon-arrow-left'></i>"],
          responsiveClass: true,
          responsive: {
            0: {
              items: 2,
            },
            640: {
              items: 3,
            },
            980: {
              items: 4,
            },
            1280: {
              items: 5,
            }
          },
        });
      }

      var customOwl = $(".custom-owl-carousel");
      if (customOwl.length > 0) {
        customOwl.owlCarousel({
          autoplay: false,
          slideSpeed: 50,
          rewindSpeed: 50,
          loop: true,
          rtl: true,
          margin: 10,
          nav: true,
          navText: ["<i class='icon-arrow-right'></i>", "<i class='icon-arrow-left'></i>"],
          responsiveClass: true,
          responsive: {
            0: {
              items: 1,
            },
            320: {
              items: 1,
            },
            640: {
              items: 3,
            },
            980: {
              items: 4,
            },
            1200: {
              items: 4,
            }
          },
        });
      }
    });

  });

